module.exports = __webpack_public_path__ + "static/media/人机协作-插画2x.2fe7dd5d.png";